import { jwtDecode } from 'jwt-decode';
import LocalStorage from 'quasar/src/plugins/storage/LocalStorage.js';;
import Notify from 'quasar/src/plugins/notify/Notify.js';


const clientId = process.env.VUE_APP_COGNITO_CLIENT_ID;
const redirectUri = process.env.VUE_APP_COGNITO_CALLBACK_URI;
const tokenUrl = process.env.VUE_APP_COGNITO_AUTH_URL + '/oauth2/token';
const scopes = process.env.VUE_APP_COGNITO_SCOPES;
const client_secret = process.env.VUE_APP_COGNITO_CLIENT_SECRET;

export async function fetchToken(code, router) {
  const params = new URLSearchParams();

  params.append('client_id', clientId);
  params.append('grant_type', 'authorization_code');
  params.append('code', code);
  params.append('redirect_uri', redirectUri);
  params.append('scope', scopes);
  params.append('client_secret', client_secret);

  try {
    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params
    });

    const data = await response.json();

    if (data.access_token == null || data.access_token == undefined) {
      router.push("/");
    }

    localStorage.setItem("token", data.id_token);
    localStorage.setItem("token_type", data.token_type);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("isAuthenticated", true);

    // console.log(data)

    const decodedToken = jwtDecode(localStorage.getItem("token"));
    localStorage.setItem("tokenExpirationTime", decodedToken.exp);

    let userData = JSON.parse(atob(data.id_token.split('.')[1]));

    localStorage.setItem("user", userData.name);
    localStorage.setItem("grupo", userData["custom:roles"]);

    router.push("/ListarOcorrencias");
  } catch (error) {
    console.error('Error fetching token:', error);
    router.push("/");
  }
}

export function logout() {
  LocalStorage.clear();
  const url = `${process.env.VUE_APP_COGNITO_AUTH_URL}/logout?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes}`;
  window.location.href = url;
}

export async function refreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");
  const params = new URLSearchParams();

  params.append('client_id', clientId);
  params.append('grant_type', 'refresh_token');
  params.append('refresh_token', refreshToken);
  params.append('redirect_uri', redirectUri);
  params.append('scope', scopes);

  try {
    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params
    });

    const data = await response.json();

    if (!data.access_token) {
      throw new Error("Failed to refresh token");
    }

    localStorage.setItem("token", "Bearer " + data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);

    const decodedToken = jwtDecode(localStorage.getItem("token"));
    localStorage.setItem("tokenExpirationTime", decodedToken.exp);

    const userData = JSON.parse(atob(data.id_token.split('.')[1]));
    localStorage.setItem("user", userData.name);

  } catch (error) {
    console.error('Error refreshing token:', error);
    // logout();
  }
}


export async function validToken() {
  const tokenExpirationTime = localStorage.getItem('tokenExpirationTime');

  if (tokenExpirationTime === null || tokenExpirationTime === undefined) {
    console.log("Data de expiração de token nula ou em branco");
    window.location.href = "/";
    return;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  // console.log(currentTime + " - " + tokenExpirationTime);

  if (currentTime > tokenExpirationTime) {
    localStorage.clear();
    Notify.create({
      spinner: true,
      message: 'Atualizando sua sessão para manter a segurança. Por favor, aguarde um momento.',
      timeout: 3000,
      position: 'center'
    });
    await new Promise(resolve => setTimeout(resolve, 3000));
    window.location.href = "/";
  }
}
